/**
 * Video duration utility functions
 */

/**
 * Format time in seconds to HH:MM:SS or MM:SS
 * @param {number} time - Time in seconds
 * @returns {string} - Formatted time
 */
export const formatTime = (time) => {
	let seconds = Math.floor(time % 60);
	let minutes = Math.floor(time / 60) % 60;
	let hours = Math.floor(time / 3600);

	seconds = seconds < 10 ? `0${seconds}` : seconds;
	minutes = minutes < 10 ? `0${minutes}` : minutes;
	hours = hours < 10 ? `0${hours}` : hours;

	if (hours == 0) {
		return `${minutes}:${seconds}`;
	}
	return `${hours}:${minutes}:${seconds}`;
};
